class LookbookComponent extends HTMLElement {

  constructor () {
    super()
  }

  connectedCallback () {
    const viewGridBtn = this.querySelectorAll('.view-grid')
    const lookbook = this
    const viewSliderBtn = this.querySelector('.view-slider')
    const slider = this.querySelector('.lookbook-slider')
    const grid = this.querySelector('.lookbook-grid')
    const gridItems = this.querySelectorAll('.lookbook-grid-item')
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    viewGridBtn.forEach(viewGridBtnItem => {
      viewGridBtnItem.addEventListener('click', function () {
        grid.classList.remove('hide')
        slider.classList.add('hide')
        const lookbook = document.querySelector('lookbook-component');
        const elementTop = lookbook.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          behavior: 'smooth',
          top: elementTop
        });
      })
    })

    gridItems.forEach(gridItemsItem => {
      gridItemsItem.addEventListener('click', (event) => {
        const index = event.currentTarget.getAttribute('data-index')
        this.swiper.slideTo(index)
        grid.classList.add('hide')
        slider.classList.remove('hide')
        const lookbook = document.querySelector('lookbook-component');
        const elementTop = lookbook.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          behavior: 'smooth',
          top: elementTop
        });
      })
    })
    viewSliderBtn.addEventListener('click', function () {
      grid.classList.add('hide')
      slider.classList.remove('hide')
      const lookbook = document.querySelector('lookbook-component');
      const elementTop = lookbook.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        behavior: 'smooth',
        top: elementTop
      });
    })
  }
}

if (!customElements.get('lookbook-component')) {
  customElements.define('lookbook-component', LookbookComponent)
}
